export default __webpack_public_path__ + "static/rexit-e6c276d610a074cb76931365c616b3e7.webp";